{
  "$id": "wealthlane://forms/job-scheduler/orch",
  "$schema": "wealthlane://schemas/form-orch",
  "submitBar": {
    "submitLabel": "Save to Activate",
    "align": "start"
  },
  "layout": [
    {
      "rowId": "basics",
      "title": "",
      "fields": [
        {
          "scope": "#/properties/name",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 280,
          "maxWidthPx": 640
        },
        {
          "scope": "#/properties/description",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 280,
          "maxWidthPx": 640
        }
      ]
    },
    {
      "type": "column-group",
      "rowId": "schedule_start",
      "style": { "marginTop": "1.2rem", "marginBottom": "1.2rem" },
      "columnTemplate": "minmax(48px, 1fr) minmax(0, 3fr) minmax(0, 3fr)",
      "columns": [
        {
          "fields": [
            {
              "scope": "#/properties/recurrenceStartWeekdayHint",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 40,
              "maxWidthPx": 72,
              "hideLabel": true,
              "style": { "alignSelf": "center", "paddingTop": 26, "textAlign": "center" }
            }
          ]
        },
        {
          "fields": [
            {
              "scope": "#/properties/recurrenceStartDate",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 100,
              "maxWidthPx": 480
            }
          ]
        },
        {
          "fields": [
            {
              "scope": "#/properties/recurrenceStartTime",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 100,
              "maxWidthPx": 480
            }
          ]
        }
      ]
    },
    {
      "rowId": "recurrence",
      "title": "",
      "columns": 3,
      "fields": [
        {
          "scope": "#/properties/recurrenceTypeId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 280,
          "maxWidthPx": 480
        },
        {
          "scope": "#/properties/recurrenceDisplayText",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 200,
          "maxWidthPx": 480,
          "hideLabel": true
        }
      ]
    },
    {
      "rowId": "timezone",
      "title": "",
      "fields": [
        {
          "scope": "#/properties/recurrenceInstructionsJson/properties/timeZone",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 280,
          "maxWidthPx": 480
        }
      ]
    },
    {
      "rowId": "task_type",
      "title": "",
      "fields": [
        {
          "scope": "#/properties/taskTypeId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 280,
          "maxWidthPx": 480
        }
      ]
    },
    {
      "rowId": "custom_report",
      "title": "",
      "collapseWhenEmpty": true,
      "fields": [
        {
          "scope": "#/properties/taskInstruction/properties/taskDetailId",
          "minCols": 1,
          "maxCols": 2,
          "minWidthPx": 280,
          "maxWidthPx": 520
        },
        {
          "type": "action-button",
          "actionId": "OPEN_REPORT_DESIGNER",
          "align": "start",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 120,
          "maxWidthPx": 160,
          "style": {
            "paddingTop": 0
          }
        }
      ]
    },
    {
      "rowId": "automation",
      "title": "",
      "collapseWhenEmpty": true,
      "fields": [
        {
          "scope": "#/properties/taskInstruction/properties/taskExecutionDto/properties/awardTypeId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 280,
          "maxWidthPx": 480
        },
        {
          "scope": "#/properties/taskInstruction/properties/taskExecutionDto/properties/grantIds",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 280,
          "maxWidthPx": 480,
          "startNewRow": true
        },
        {
          "scope": "#/properties/taskInstruction/properties/taskExecutionDto/properties/settlementTypeIds",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 280,
          "maxWidthPx": 480,
          "startNewRow": true
        },
        {
          "scope": "#/properties/taskInstruction/properties/taskExecutionDto/properties/timeInterval",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 200,
          "maxWidthPx": 480,
          "startNewRow": true
        },
        {
          "scope": "#/properties/taskInstruction/properties/taskExecutionDto/properties/configuration",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 280,
          "maxWidthPx": 480,
          "startNewRow": true
        }
      ]
    }
  ]
}
